import React from "react";

import { Helmet } from "react-helmet";

const HelmetBlock = React.memo(({ title, description, url }) => (
  <Helmet title={title}>
    <meta key="og:title" property="og:title" content={title} />
    <meta key="og:type" property="og:type" content="website" />
    <meta key="og:url" property="og:url" content={url} />
    {description ? (
      <meta
        key="og:description"
        name="description"
        property="og:description"
        content={description}
      />
    ) : null}
    <title>{title}</title>
  </Helmet>
));

export default HelmetBlock;



// WEBPACK FOOTER //
// ./src/components/HelmetBlock.js